<template>
  <div class="pangod-classify">
    <!-- 顶部 -->
    <BreadCrumb :routeArr="routeArr" v-if="!isMobile"></BreadCrumb>

    <!-- 二级导航栏 -->
    <TypeNavs
      :activeCode="activeCode"
      :tabNavList="tabNavList"
      @changeNav="changeNav"
    />
    <!-- 内容 -->
    <!-- 除招贤纳士和联系我们的其他一级导航栏 -->
    <div class="pangod-classify-content">
      <CustomLoading v-show="vanLoading" />
      <div class="honor-box">
        <div
          class="honor-item"
          v-for="item in honorList"
          :key="item.id"
          @click="up(item.imgUrl)"
        >
          <div class="left">
            <img :src="URL + item.imgUrl" />
          </div>
          <div class="right">
            <p class="title">{{ item.title }}</p>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
      <div class="up" v-show="nowImage" @click="close">
        <img class="close" src="@/assets/classify/close.png" alt="" />
        <img class="show" :src="nowImage" alt="" @click.stop />
      </div>
    </div>
  </div>
</template>
<script>
import Macy from "macy";
import BreadCrumb from "@/components/breadCrumb.vue";
import CustomLoading from "@/components/loading.vue";
import TypeNavs from "../components/typeNavs.vue";
import { URL } from "@/util/config.js";
import { Store } from "../store";
import { mapState } from "pinia";
export default {
  data() {
    return {
      URL,
      honorList: [],
      nowImage: "",
      tabNavList: [],
      activeCode: "",
      params: {
        pageIndex: 1,
        pageSize: 12,
        newsCode: undefined,
        typeCode: undefined,
      },
      routeArr: [],
      vanLoading: false,
      detail: {},
    };
  },
  components: {
    BreadCrumb,
    CustomLoading,
    TypeNavs,
  },
  computed: {
    ...mapState(Store, ["isMobile", "navList"]),
    // 富文本手机端兼容mobileContentStr字段
    handleHTML() {
      const { contentStr, mobileContentStr } = this.detail;
      if (this.isMobile) {
        return mobileContentStr || contentStr;
      } else {
        return contentStr;
      }
    },
  },
  mounted() {
    // 从其他路由到classify路由 或 首次进入网页为classify时
    this.setPageConfig();
  },
  methods: {
    // 初始化瀑布流
    initWaterFall() {
      Macy({
        container: ".honor-box",
        trueOrder: true,
        waitForImages: false,
        margin: 24,
        columns: 4,
        breakAt: {
          1300: 3,
          750: 2,
        },
      });
    },
    // 构建页面参数
    setPageConfig() {
      const query = this.$route.params;
      // 父子id
      const { id, childId } = query;
      let nowDic = {};
      out: for (const i in this.navList) {
        const ele = this.navList[i];
        if (ele.id == id) {
          // 获取二级分类
          this.tabNavList = ele.children;
          if (childId) {
            // 两个参数
            for (const j in ele.children) {
              const child = ele.children[j];
              // 获取激活字典
              if (child.id == childId) {
                nowDic = child;
                this.getList(nowDic);
                break out;
              }
            }
          } else {
            // 一级字典
            nowDic = ele;
            this.getList(nowDic);
            break;
          }
        }
      }
      this.activeCode = nowDic.code;
      this.routeArr = [{ name: "首页", path: "/" }, nowDic.name];
    },
    // 获取内容
    getList(val) {
      this.params.newsCode = val.code;

      this.vanLoading = true;

      const formData = { honorType: 0 };
      //获取列表
      this.$api
        .sysHonorList(formData)
        .then((res) => {
          if (res.code === 0) {
            this.honorList = res.data;
            // this.initWaterFall();
          }
        })
        .finally(() => {
          this.vanLoading = false;
        });
    },
    // 切换菜单
    changeNav(val) {
      this.$router.push(
        val.templateName + "_" + this.$route.params.id + "/" + val.id
      );
    },
    up(url) {
      this.nowImage = this.URL + url;
    },
    close() {
      this.nowImage = "";
    },
  },
};
</script>
<style lang="scss" scoped>
@function pxToRem($args) {
  @return calc($args / 50) + rem;
}

.pangod-classify {
  font-size: 16px;
  background-color: #eeeef0;

  --frame-width: 1500px;

  &::before {
    content: "";
    display: table;
  }

  .navBar {
    background: #eeeef0;

    .pangod-classify-nav {
      width: var(--frame-width);
      margin: 0 auto;
      background-color: #fff;
      line-height: 60px;

      .pangod-classify-nav-ul {
        border-bottom: 1px solid #e9e9e9;
        display: flex;
        justify-content: center;

        .pangod-classify-nav-li {
          padding: 0 20px;
          text-align: center;
          cursor: pointer;
        }
      }
      .active {
        color: rgba(2, 69, 140, 0.7);
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 50%;
          height: 3px;
          background: rgba(2, 69, 140, 0.7);
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          z-index: 2;
          opacity: 1;
        }
      }
    }
  }

  .pangod-classify-content {
    width: var(--frame-width);
    margin: 0 auto 20px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #ffffff;

    .van-loading {
      text-align: center;
    }
    .honor-box {
      display: flex;
      flex-wrap: wrap;

      .honor-item {
        width: 23%;
        margin: 0 20px 20px 0;

        &:hover {
          cursor: zoom-in;
        }
        .left {
          width: 100%;

          img {
            width: 100%;
            height: 450px;
            object-fit: contain;
          }
        }

        .right {
          text-align: center;

          .title {
            font-weight: normal;
          }
        }
      }
    }

    .up {
      width: 100%;
      height: 100%;
      overflow: auto;
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 999;
      background-color: rgba($color: #000000, $alpha: 0.6);

      .close {
        position: absolute;
        right: 10px;
        top: 20px;
        z-index: 10;
        cursor: pointer;
      }
      .show {
        max-width: 80%;
        max-height: 80%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
@media (max-width: 1600px) {
  .pangod-classify {
    --frame-width: 1200px;
  }
  .pangod-classify .pangod-classify-content {
    padding: pxToRem(10) pxToRem(20);
    box-sizing: border-box;

    .pangod-classify-html {
      width: 100%;

      table {
        max-width: 100% !important;
        height: auto !important;
        margin: 0 auto;

        tr {
          height: auto !important;

          td {
            height: auto !important;
            padding-left: 0 !important;
          }
        }
      }
    }
    .honor-box .honor-item .left img {
      height: 330px;
    }
  }
  .pangod-classify-nav-li {
    font-size: 14px;
  }
}
@media (max-width: 1300px) {
  .pangod-classify {
    --frame-width: 1000px;

    .pangod-classify-content .honor-box .honor-item {
      width: 33%;
      margin: 0 2px 10px 0;
    }
  }
}
@media (max-width: 1200px) {
  .pangod-classify {
    --frame-width: 100%;
  }
  .pangod-classify .pangod-classify-content {
    box-sizing: border-box;
    margin-bottom: pxToRem(10);
  }

  .pangod-classify .navBar .pangod-classify-nav {
    line-height: 30px;

    .pangod-classify-nav-ul {
      justify-content: start;
      white-space: nowrap;
      overflow-x: scroll;
      padding: pxToRem(5) pxToRem(10);
    }
  }
}
@media (max-width: 1024px) {
  .pangod-classify .pangod-classify-html {
    overflow-x: auto;
  }
}
@media (max-width: 750px) {
  .pangod-classify {
    .pangod-classify-content {
      .up .close {
        width: 40px;
      }
      .honor-box .honor-item {
        width: 48%;
        margin: 0 5px 10px 0;

        .left img {
          height: 210px;
        }
        .right .title {
          font-size: 13px;
        }
      }
    }
  }
  .pangod-classify .navBar .pangod-classify-nav {
    line-height: pxToRem(40);

    .pangod-classify-nav-ul {
      font-size: pxToRem(15);
    }
  }
}
</style>
